import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  padding: 70px 0;
  width: 100%;
  flex-direction: column;
  background: linear-gradient(180deg, #000814 0%, #020817 100%);
  border-top: 1px solid rgba(59, 130, 246, 0.22);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  box-sizing: border-box;

  @media (max-width: 1000px) {
    padding: 70px 30px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const WideColumn = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  grid-column: span 2;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 15px;
  margin-bottom: 30px;
  width: 100%;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
`;

export const Link = styled.a`
  color: #d6e5ff;
  margin-bottom: 20px;
  font-size: 13px;
  text-decoration: none;

  &:hover {
    color: #ffffff;
  }
`;

export const Title = styled.p`
  font-size: 16px;
  color: #d6e5ff;
  margin-bottom: 40px;
`;

export const Text = styled.p`
  font-size: 13px;
  color: #d6e5ff;
  margin-bottom: 40px;
`;

export const Break = styled.div`
  flex-basis: 100%;
  height: 0;
`;

export const Logo = styled.img`
  width: 120px;
  margin-bottom: 20px;
`;

export const BadgeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
`;

export const Badge = styled.img`
  width: 100px;
  height: auto;
`;

export const QRSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const QRCode = styled.img`
  width: 80px;
  height: 80px;
  border: 2px solid #333;
  border-radius: 8px;
  padding: 5px;
  background: white;
`;

export const AppButtons = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const AppButton = styled.img`
  width: 120px;
  height: auto;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }
`;

export const InfoSection = styled.div`
  color: #d6e5ff;
  font-size: 12px;
  line-height: 1.8;
`;

export const ColumnTitle = styled.h3`
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
